import { IAppEnvironment } from '../utils/interfaces/environment.model';

export const environment: IAppEnvironment = {
  production: false
};
